import {COMMON_BUILDING_TOKENS} from "../../constants/tokens";

export const getAllQuartersOfCity = (city) => {
  // Собираем все кварталы города - центральный квартал и базовые кварталы
  const allQuarters = [city.centralQuarter];
  if (city[COMMON_BUILDING_TOKENS.QUARTER]) {
    allQuarters.push(...city[COMMON_BUILDING_TOKENS.QUARTER]);
  }

  return allQuarters;
}